export default __webpack_public_path__ + "static/media/brand-11.efbddbb4.png";